import React from 'react';

import { defaultTo } from 'ramda';

import ribbon_with_star_icon from '../../../images/ribbon_with_star_icon.svg';

import { FOHImage } from '../../ingredients';

export const FOHPremiumPlanIcon = (props: any) => (
  <FOHImage
    source={{ uri: ribbon_with_star_icon }}
    style={{ width: 64, height: 64, ...defaultTo({}, props.style) }}
  />
);
